export default __webpack_public_path__ + "static/media/logo-33-pilot-beach-resort.494a72b7.jpg";